import { useMemo, useEffect, useContext } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { DoubleListBoxContext } from '@bingads-webui-react/double-list-box-fluent';

export const DataSource = ({ campaignData }) => {
  const {
    state: {
      pageSize,
      pageNumber,
      search,
    },
    dispatch,
  } = useContext(DoubleListBoxContext);

  const data = useMemo(() => campaignData.value.map(camp => ({ id: camp.Id, name: camp.Name })), [campaignData.value]);

  useEffect(() => {
    dispatch({ type: 'START_LOAD_DATA' });

    _.delay(() => {
      const items = search ? data.filter(item => item.name.toLowerCase().includes(search.toLowerCase())) : data;
      const start = (pageNumber - 1) * pageSize;
      const end = pageNumber * pageSize > items.length ? items.length : pageNumber * pageSize;
      dispatch({
        type: 'FINISH_LOAD_DATA',
        payload: {
          items: items.slice(start, end),
          totalCount: items.length,
        },
      });
    }, 100);
  }, [data, dispatch, pageNumber, pageSize, search]);

  return null;
};

DataSource.propTypes = {
  campaignData: PropTypes.shape({
    value: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })).isRequired,
  }).isRequired,
};
